import axios from "axios";

const jwtAxios = axios.create({
    baseURL:process.env.REACT_APP_API_BASE_URL,
    
  headers: {
    "Content-Type": "application/json",
  },
});
jwtAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (
      err.response &&
      (err.response.data.msg === "Token is not valid" || err.response.status === 401 ||  err.response.status === 400)
    ) {
      console.warn("Token expired or invalid. Logging out user...");

      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      delete jwtAxios.defaults.headers.common.Authorization;

      window.location.href = "/signin";
    }
    return Promise.reject(err);
  }
);
export const setAuthToken = (token?: string) => {
  if (token) {
    const accesstoken =localStorage.getItem("token")
    jwtAxios.defaults.headers.common.Authorization = `Bearer ${accesstoken}`;
    localStorage.setItem("token", token);
  } else {
    const accesstoken =localStorage.getItem("token1")
    jwtAxios.defaults.headers.common.Authorization = `Bearer ${accesstoken}`;
  }
};

export default jwtAxios;
